import { Palette } from 'core/config';
import React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { Button, Card, CardHeader, CardBody, CardFooter } from 'view/components/common';
import { StepProps } from '../MortgageApplicationPage';

export const Introduction : React.FunctionComponent<StepProps> = ({ setStep, progressForward }) => 
{
    const history = useHistory();
    return (
        <Container>
            <Card height={600}>
                <CardHeader 
                    content='Apply for a Manzil Mortgage'
                    step='Step 1'
                    backText='Back'
                    backHandler={() => history.push('/dashboard')}
                />
                <CardBody>
                    <Paragraph>
                        Expect to spend 15 minutes completing this application. In the event you need to leave partway through the process, we will save your progress so you can pick up where you left off.
                    </Paragraph>
                    <Paragraph>
                        <span>Step 1</span> in obtaining a mortgage from Manzil is to tell us which type of mortgage you are applying for.
                    </Paragraph>
                    <Paragraph>
                        As always, if you have any questions or concerns, please email us at salaam@manzil.ca for help.
                    </Paragraph>
                </CardBody>
                <CardFooter>
                    <Button
                        title='Continue'
                        type='button'
                        onClick={() =>
                        {
                            setStep(s => s + 1);
                            progressForward();
                        }}
                    />
                </CardFooter>
            </Card>
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
    height: calc(100vh - 200px);
`;

const Paragraph = styled.p`
    padding-top: 6px;

    :first-child {
        padding-top: 15px;
    }

    padding-left: 60px;
    padding-right: 60px;
    font: normal normal normal 10px 'SofiaPro-Regular';
    color: ${Palette.BLUE};
    font-weight: 200;

    span {
        font: normal normal normal 10px 'SofiaPro-Bold';
    }

    @media only screen and (min-width: 1300px) {
        font-size: 12px;

        span {
            font-size: 12px;
        }
    }

    @media only screen and (min-width: 1900px) {
        font-size: 14px;

        span {
            font-size: 14px;
        }
    }
`;